<template>
  <layout>
    <div v-if="isAccessEnable == false">
      <b-card>
        <h4>You dont have access to view this page</h4>
      </b-card>
    </div>
    <div v-else>
      <b-card>
        <b-row>
          <b-col cols="5">
            <b-form-group
              label="Date from"
              label-for="groupSelect"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                id="brand"
                type="date"
                v-model="fromdate"
                placeholder="Enter First Name"
                required
                validate
              />
            </b-form-group>
          </b-col>
          <b-col cols="5">
            <b-form-group
              label="Date To"
              label-for="groupSelect"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                id="brand"
                type="date"
                v-model="todate"
                placeholder="Enter First Name"
                required
                validate
              />
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <button
              type="button"
              class="btn btn-success"
              @click="generateSalesReport()"
            >
              <i class="" />
              Generate
            </button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-4">
        <b-row class="mt-1 mb-0">
          <h2 style="margin-left: auto; margin-right: auto; color: black">
            Sales Report
          </h2>
        </b-row>
        <b-row class="mt-0 pt-0 mb-3">
          <h4 style="margin-left: auto; margin-right: auto; color: black;">
            from {{ fromdate }} - to {{ todate }}
          </h4>
        </b-row>

        <table class="table" id="TableList">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Payment Date</th>
              <th scope="col">Invoice Number</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Payment Type</th>
              <th scope="col">Payment Mode</th>
              <th scope="col">Amount</th>
              <th scope="col">Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(payment, index) in payment" :key="payment._id">
              <td>{{ payment.payment_date }}</td>
              <td>{{ payment.invoice_number }}</td>
              <td>{{ payment.member_name }}</td>
              <td>{{ payment.payment_type }}</td>
              <td>{{ payment.payment_details.payment_type }}</td>
              <td>
                {{ parseFloat(payment.payment_details.amount).toFixed(2) }}
              </td>
              <td>{{ payment.remarks }}</td>
              <!-- <td>
              <b-button
                :key="member._id"
                class="btn btn-info btn-md"
                @click="editMember(member)"
              >
                <i class="cui-pencil" />
                Edit
              </b-button>
            </td> -->
            </tr>
          </tbody>
        </table>

        <b-row class="ml-1">
          <b-col cols="8"></b-col>
          <b-col cols="4">
            <b-form-group
              label="Total"
              label-for="groupSelect"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                disabled
                id="brand"
                type="text"
                v-model="totalSales.toFixed(2)"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="ml-1">
          <b-col cols="8"></b-col>
          <b-col cols="4">
            <b-form-group
              label="Total Invoices"
              label-for="groupSelect"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                disabled
                id="brand"
                type="number"
                v-model="totalInvoices"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </layout>
</template>

<script>
import Layout from '@layouts/main'
import { memberMethods, paymentMethods } from '@state/helpers'

export default {
  name: 'unpaid',
  components: {
    Layout,
  },
  page: {
    title: 'Unpaid Members',
  },
  data() {
    return {
      members: [],
      payment: [],
      fromdate: '',
      todate: '',
      filter: null,
      filterNIC: null,
      currentDate: new Date(),
      totalSales: 0,
      totalInvoices: 0,
      isAccessEnable: true,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    let userType = localStorage.getItem('userType')
    if (userType == null) {
      this.isAccessEnable = false
    } else if (userType == 1) {
      this.isAccessEnable = true
    } else {
      this.isAccessEnable = false
    }

    this.fromdate = this.formattedDate()
    this.todate = this.formattedDate()
  },
  methods: {
    ...memberMethods,
    ...paymentMethods,
    async generateSalesReport() {
      this.totalInvoices = 0
      this.totalSales = 0
      let q = {
        selector: {
          type: 'payment',
          payment_date: {
            $gte: this.fromdate,
            $lte: this.todate,
          },
        },
        limit: 10000000,
      }
      let response = await this.getPaymentForcurrentDate(q)

      if (response.docs.length > 0) {
        let res = response.docs.sort(
          (a, b) => b.invoice_number - a.invoice_number
        )

        this.payment = res
        this.totalInvoices = this.payment.length

        for (const payment of this.payment) {
          this.totalSales += parseFloat(payment.payment_details.amount)
        }
      } else {
        this.payment = []
        this.totalInvoices = 0
        this.totalSales = 0
      }
    },
    formattedDate() {
      const date = this.currentDate
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
  },
}
</script>
